'use client';

import { VipProgramPage } from '@flipster/features/src/vip-program-page';

import { Footer } from '@web/app/_layout/footer';

const Page = () => {
  return (
    <>
      <VipProgramPage />
      <Footer />
    </>
  );
};

export default Page;
